import React, { useState } from "react";
import { TextField, Button, Box } from "@mui/material";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import "dayjs/locale/es"; // Importar español

const Encargados = ({ onSubmit }) => {
  const [formData, setFormData] = useState({
    nombre: "",
    nif: "",
    domicilio: "",
    codigoPostal: "",
    poblacion: "",
    provincia: "",
    tipoServicio: "",
    fechaAntiguedad: null, // Cambiar a null para DatePicker
  });

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleDateChange = (date) => {
    setFormData((prev) => ({
      ...prev,
      fechaAntiguedad: date ? dayjs(date).format("YYYY-MM") : "",
    }));
  };

  const handleSubmit = () => {
    onSubmit(formData);
  };

  return (
    <Box>
      <p style={{ fontSize: "13px", color: "gray", marginBottom: "10px" }}>
        Ficha a rellenar con los datos de cualquier empresa o autónomo que al
        prestar un servicio pueda gestionar los datos de sus clientes (como, por
        ejemplo, informáticos, asesoría laboral, programas de gestión con
        servicios de control remoto, empresas destructoras de papel,
        colaboradores externos).
      </p>
      <TextField
        fullWidth
        label="Nombre (de la empresa que presta el servicio)"
        name="nombre"
        value={formData.nombre}
        onChange={handleChange}
        margin="normal"
      />
      <TextField
        fullWidth
        label="N.I.F."
        name="nif"
        value={formData.nif}
        onChange={handleChange}
        margin="normal"
      />
      <TextField
        fullWidth
        label="Domicilio"
        name="domicilio"
        value={formData.domicilio}
        onChange={handleChange}
        margin="normal"
      />
      <TextField
        fullWidth
        label="Código Postal (C.P.)"
        name="codigoPostal"
        value={formData.codigoPostal}
        onChange={handleChange}
        onInput={(e) => {
          e.target.value = e.target.value.replace(/\D/g, "").slice(0, 5);
        }}
        margin="normal"
      />
      <TextField
        fullWidth
        label="Población"
        name="poblacion"
        value={formData.poblacion}
        onChange={handleChange}
        margin="normal"
      />
      <TextField
        fullWidth
        label="Provincia"
        name="provincia"
        value={formData.provincia}
        onChange={handleChange}
        margin="normal"
      />
      <TextField
        fullWidth
        label="Tipo de servicio que presta"
        name="tipoServicio"
        value={formData.tipoServicio}
        onChange={handleChange}
        margin="normal"
      />

      {/* DatePicker para Fecha de Antigüedad */}
      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
        <DatePicker
          views={["year", "month"]}
          label="Fecha de antigüedad"
          value={
            formData.fechaAntiguedad ? dayjs(formData.fechaAntiguedad) : null
          }
          onChange={handleDateChange}
          sx={{ width: "100%" }}
          renderInput={(params) => (
            <TextField fullWidth margin="normal" {...params} />
          )}
        />
      </LocalizationProvider>

      <Button
        variant="contained"
        color="primary"
        fullWidth
        sx={{ mt: 2 }}
        onClick={handleSubmit}
      >
        Guardar Información
      </Button>
    </Box>
  );
};

export default Encargados;
